import React from 'react';

const Error = ( {errorMessage} ) => {

    return (
        <div className="text-xs text-red-400 ml-4 mt-2 tracking-normal">{errorMessage}</div>
    )
}

export default Error;